import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

import { AnalyticsEventsResponse } from '../types/AnalyticsEvent';

type GetUsageAnalyticsEventsProps = {
  societyId: string;
  feature: string;
  fromDate?: string;
  toDate?: string;
  actions?: string[];
  partnerId?: string;
  limit?: number;
  cursor?: string;
  page?: number;
  partnerSearch?: string;
};

export const getUsageAnalyticsEvents = async ({
  societyId,
  feature,
  fromDate,
  toDate,
  actions,
  partnerId,
  limit,
  cursor,
  page,
  partnerSearch,
}: GetUsageAnalyticsEventsProps): Promise<AnalyticsEventsResponse> => {
  const params: Record<string, string | number> = { societyId, feature };
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (actions?.length) params.actions = actions.join(',');
  if (partnerId) params.partnerId = partnerId;
  if (limit) params.limit = limit;
  if (cursor) params.cursor = cursor;
  if (page != null) params.page = page;
  if (partnerSearch?.trim()) params.partnerSearch = partnerSearch.trim();

  const { data } = await axiosV2.get('/usage-analytics/events', { params });
  const decoded: any = await decryptResponse(data);
  return decoded as AnalyticsEventsResponse;
};

export default getUsageAnalyticsEvents;
